import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const ManagerGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '12px',
  gridTemplateColumns: 'repeat(4, 1fr)',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const ManagerCard = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  border: `1px solid ${selected ? protoColors.purple : protoColors.border}`,
  backgroundColor: selected ? protoColors.purpleSoft : protoColors.surface,
  borderRadius: '12px',
  padding: '14px',
  cursor: 'pointer',
  textAlign: 'left',
  fontFamily: 'inherit',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  '&:hover': {
    borderColor: protoColors.purple,
  },
}));

export const CardHead = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
}));

export const CardName = styled('span')(() => ({
  fontSize: '14px',
  fontWeight: 700,
  color: protoColors.textPrimary,
}));

export const CardSub = styled('span')(() => ({
  fontSize: '12px',
  color: protoColors.textMuted,
}));

export const Nota = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  fontSize: '20px',
  fontWeight: 800,
  color,
  lineHeight: 1,
}));

export const CardMetrics = styled(Box)(() => ({
  display: 'flex',
  gap: '14px',
  flexWrap: 'wrap',
  fontSize: '12px',
  color: protoColors.textMuted,
  '& strong': {
    color: protoColors.textPrimary,
    fontWeight: 700,
  },
}));

export const KpiRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '12px',
  gridTemplateColumns: 'repeat(6, 1fr)',
  marginBottom: '4px',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
}));

export const Kpi = styled(Box)(() => ({
  backgroundColor: protoColors.surfaceSubtle,
  borderRadius: '10px',
  padding: '10px 12px',
}));

export const KpiLabel = styled(Typography)(() => ({
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: protoColors.textMuted,
}));

export const KpiValue = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  fontSize: '18px',
  fontWeight: 700,
  color: color ?? protoColors.textPrimary,
}));

export const Subsection = styled(Box)(() => ({
  marginTop: '18px',
}));

export const SubTitle = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: 700,
  color: protoColors.textPrimary,
  marginBottom: '10px',
}));
